import { sendToApi } from 'api/client'
import { JiraIssue } from 'common/Prose/nodeViews/JiraEmbed/types'

export interface JiraIntegration {
  jira_integration: {
    id: number
    updated_at: string
  }
}

export const JiraClient = {
  getIssue: ({ workspaceId, id }: { workspaceId: number; id: string }) =>
    sendToApi<JiraIssue>(`/w/${workspaceId}/jira/issues/${id}`),
  getIntegration: ({ workspaceId }: { workspaceId: number }) =>
    sendToApi<JiraIntegration>(`/w/${workspaceId}/jira/integration`),
  destroyIntegration: ({ workspaceId }: { workspaceId: number }) =>
    sendToApi<void>(`/w/${workspaceId}/jira/integration`, { method: 'delete' }),
  createIntegration: ({ workspaceId, code }: { workspaceId: number; code: string }) =>
    sendToApi<void>(`/w/${workspaceId}/jira/integration`, {
      body: { code },
      method: 'post',
    }),
}
